export default {
  setPlants: (state, data) => {
    state.plants.splice(0)

    // eslint-disable-next-line array-callback-return
    data.map(x => {
      state.plants.push({
        id: x.id,
        code: x.code,
        name: x.name,
        total: x.total,
        opened: x.opened,
        closed: x.closed
      })
    })
  },
}
